export { default } from './BarresVots';
